import { render, staticRenderFns } from "./PB-Share.vue?vue&type=template&id=f24aac88&scoped=true&"
import script from "./PB-Share.vue?vue&type=script&lang=js&"
export * from "./PB-Share.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24aac88",
  null
  
)

export default component.exports